import { useTranslation } from 'react-i18next';
import Shape from '../../shape';
import ICarrierOverviewProps from './interfaces/ICarrierOverviewProps';
import { phoneMask } from '../../../../utils/masks-constants';
import renderContactType from '../../../../utils/contact-type-methods';

function CarrierOverview({
    carrierData,
    carrierContactData,
}: Readonly<ICarrierOverviewProps>) {
    const { t } = useTranslation();

    const RESUME_TITLE = t('Resumo');
    const CARRIER_DATA_TITLE = t('DadoTransportadora');
    const CONTACT_TITLE = t('Contato');

    return (
        <Shape>
            <div className="container">
                <div className="infos">
                    <h1>{RESUME_TITLE}</h1>

                    <h3>{CARRIER_DATA_TITLE}</h3>

                    <h4>{t('Nome')}</h4>
                    <span>{carrierData.tradeName}</span>

                    <h4>{t('PrazoPagamento')}</h4>
                    <span>{carrierData.paymentTerm}</span>

                    <span>
                        {renderIdEgates(carrierData.legacy, carrierData.id)}
                    </span>

                    <div className="contact">{CONTACT_TITLE}</div>

                    <div className="phone-info">
                        <div className="phone">
                            <h4>{t('Telefone')}</h4>
                            <span>{phoneMask(carrierContactData.phone)}</span>
                        </div>

                        <div className="phone-type">
                            <h4>{t('TipoTelefone')}</h4>
                            <span>
                                {renderContactType(
                                    carrierContactData.contactType,
                                )}
                            </span>
                        </div>
                    </div>

                    <div className="responsible-info">
                        <div className="responsible-name">
                            <h4>{t('Responsavel')}</h4>
                            <span>{carrierContactData.responsible}</span>
                        </div>

                        <div className="responsible-occupation">
                            <h4>{t('Funcao')}</h4>
                            <span>{carrierContactData.occupation}</span>
                        </div>
                    </div>

                    <h4>Email</h4>
                    <span>{carrierContactData.email}</span>
                </div>
            </div>
        </Shape>
    );
}

const renderIdEgates = (legacy?: boolean, idEgates?: string) => {
    if (legacy) {
        return (
            <>
                <h4>Id Egates</h4>
                <span>{idEgates}</span>
            </>
        );
    }

    return '';
};

export default CarrierOverview;
